import type { JSX } from "react";

import { Badge } from "@/components/ui/badge";
import { STATUS_LABELS } from "@/lib/feedback";

export function FeedbackStatusBadge({ status }: { status: string }): JSX.Element {
  const label = STATUS_LABELS[status as keyof typeof STATUS_LABELS] ?? status;
  const variant =
    status === "resolved"
      ? "success"
      : status === "dismissed"
        ? "destructive"
        : status === "in_progress"
          ? "info"
          : "muted";
  return <Badge variant={variant}>{label}</Badge>;
}
